import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './ButtonPreferredSources.scss';
import { IMAGE_URL } from '../../../constants';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const ButtonPreferredSources = props => {
  const {
    label,
    isFloatingButton,
    ariaLabel,
    scrollThreshold = 330,
    msid,
    linkUrl,
    title,
    gaType,
  } = props;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(
    () => {
      if (!isFloatingButton) return;

      const handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        setIsVisible(scrollY > scrollThreshold);
      };

      // Add safety check for window availability
      if (typeof window !== 'undefined' && window.addEventListener) {
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Initial check
        handleScroll();

        // Cleanup
        // eslint-disable-next-line consistent-return
        return () => window.removeEventListener('scroll', handleScroll);
      }
    },
    [isFloatingButton, scrollThreshold],
  );

  const handleClick = () => {
    let typeval = 'preferred_source';
    if (isFloatingButton) {
      typeval = 'TOI Habit Index';
    }
    // GA Event tracking
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: gaType || typeval,
      label: label || 'N/A',
    });
  };

  // Nudge URL
  let linkNudgeUrl = `https://timesofindia.indiatimes.com/preferences.cms?src=${
    isFloatingButton ? 'floating' : 'nudge'
  }`;
  if (isFloatingButton) {
    linkNudgeUrl =
      'https://timesofindia.indiatimes.com/india/india-habit-index-2025/healthandfitness?utm_source=nudge&utm_medium=articleshow&utm_campaign=india_habit_index';
  }

  return (
    <div
      className={`
      ${s.buttonPreferredSources}
      ${isFloatingButton ? s.floatingButton : ''}
      ${isFloatingButton && isVisible ? s.visible : ''}
    `}
    >
      <Link
        to={linkUrl || linkNudgeUrl}
        target="_blank"
        onClick={handleClick}
        doNotChangeURL
        doNotChangeDomain
        ariaLabel={ariaLabel}
      >
        {isFloatingButton ? (
          <ImageV2
            src={`${IMAGE_URL}${msid || '125405640'}.cms`}
            alt={title || 'Preferred Sources Button'}
            aria-label={title || 'Preferred Sources Button'}
          />
        ) : (
          <ImageV2
            src={`${IMAGE_URL}123518384.cms`}
            alt={title || 'Preferred Sources Button'}
            aria-label={title || 'Preferred Sources Button'}
          />
        )}
      </Link>
    </div>
  );
};

ButtonPreferredSources.propTypes = {
  label: PropTypes.string,
  isFloatingButton: PropTypes.bool,
};

ButtonPreferredSources.defaultProps = {
  label: 'N/A',
  isFloatingButton: false,
};

export default ButtonPreferredSources;
